import { defineComponent as r, openBlock as t, createBlock as a, unref as l, mergeProps as p, withCtx as c, createElementVNode as m } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconInboxTray",
  __name: "IconInboxTray",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (d, e) => (t(), a(l(i), p(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2-.5h14A.5.5 0 0 1 19.5 5v6.25h-3.332a1.06 1.06 0 0 0-.885.473c-1.562 2.343-5.004 2.343-6.566 0a1.06 1.06 0 0 0-.885-.473H4.5V5A.5.5 0 0 1 5 4.5m14.5 8.25V18a.5.5 0 0 1-.5.5H5A.5.5 0 0 1 4.5 18v-5.25h3.105c2.167 2.974 6.623 2.974 8.79 0H19.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
